__turbopack_context__.v({
  "debug": "productShippingDebug-module-scss-module__OVdxkW__debug",
  "pre": "productShippingDebug-module-scss-module__OVdxkW__pre",
  "summary": "productShippingDebug-module-scss-module__OVdxkW__summary",
});
